import React, { useState } from 'react'
import { apiURL } from '../utilities/URLs'

import setcLogo from '../assets/images/craig_setcLogo.png'
import { useTheme } from '../ThemeContext'

export default function RequestPasswordReset() {
  const { isDarkMode } = useTheme()

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')

  const handleSubmit = async () => {
    setLoading('Requesting Reset...')

    const updatedPasswordResponse = await fetch(`${apiURL}/api/requestPasswordReset?email=${encodeURIComponent(email)}`)

    const updatedPasswordData = await updatedPasswordResponse.json()

    if(updatedPasswordData.response.error) {
      setLoading('')
      setError(updatedPasswordData.response.error)
      setTimeout(() => {
        setError('')
      }, 2000)
    } else {
      setLoading(`Email Sent to ${email}, Check Your Inbox!`)
      setEmail('')
    }
  }

  return (
    <div className='flex flex-col items-center justify-center h-svh'>
      <img className='w-60 mb-28' src={setcLogo} alt='setcLogo' />
      <div className={`w-full max-w-xs p-8 rounded-lg shadow mb-28 text-center ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <h1 className={`mb-10 text-center ${isDarkMode && 'text-white'}`}>Reset Password Request</h1>
        <div className='mb-4'>
          <label htmlFor='email' className={`block mb-2 text-sm font-bold text-left ${isDarkMode ? 'text-white' : "text-gray-700"}`}>
            Email
          </label>
          <input
            type='email'
            id='email'
            className={`w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className='flex justify-center'>
          <button onClick={() => handleSubmit()} type='submit' className='px-4 py-2 font-bold text-white bg-primaryColor rounded hover:bg-primaryDarkColor focus:outline-none focus:shadow-outline mt-5'>
            Request Reset
          </button>
        </div>
        {loading.length > 0 && (
          <p className={`mt-5 ${isDarkMode && 'text-white'}`}>{loading}</p>
        )}
        {error.length > 0 && (
          <p className='text-red-600 mt-5'>{error}</p>
        )}
      </div>
    </div>
  )
}